import HttpError from "./HttpError";

export const customHttpClient = (url, options = {}) => {
    if (!("headers" in options)) {
        options.headers = new Headers({})
    }
    const authTokenLocalstorageItem = localStorage.getItem("supabase.auth.token");

    if (authTokenLocalstorageItem !== null) {
        const authToken = JSON.parse(authTokenLocalstorageItem);
        const currentSession = authToken.currentSession

        // covering an edge case here: If we open the admin page and close it and
        // then access the normal frontend page again, we get an 401 error if enough time passed and
        // our access token is not valid anymore. But for requests from the frontend page we dont need
        // any access tokens (because these are all public routes), therefore only include the access
        // token in the header if we are still inside the expires_at timeframe
        if (Math.floor(Date.now() / 1000) <= currentSession.expires_at) {
            options.headers.append('Authorization', "Bearer " + currentSession.access_token);
            options.headers.append('authenticated', true);
        }
    }
    options.headers.append('apikey', process.env.REACT_APP_SUPABASE_API_KEY);

    return fetch(url, { ...options })
        .then(response =>
            response.text().then(text => ({
                status: response.status,
                statusText: response.statusText,
                headers: response.headers,
                body: text,
            }))
        )
        .then(({ status, statusText, headers, body }) => {
            let json;
            try {
                json = JSON.parse(body);
            } catch (e) {
                // not json, no big deal
            }
            if ((status < 200 || status >= 300) && status !== 406) {
                // ignore 406 status, since this blocks the deletion of entries for some reason
                return Promise.reject(
                    new HttpError(
                        (json && json.message) || statusText,
                        status,
                        json
                    )
                );
            }
            return Promise.resolve({ status, headers, body, json });
        });
};